import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/file-version';

export class FileVersionServiceV1 implements types.Handlers {
  private readonly endpoint = '/v1/file-versions';

  constructor(private axios: AxiosInstance) {}

  async getFileVersionUrl(
    params: types.GetFileVersionUrlParameters,
  ): Promise<common.GetUrlResponse> {
    const { data } = await this.axios.get<common.GetUrlResponse>(
      `${this.endpoint}/${params.path.fileVersionId}/url`,
      { params: params.query },
    );
    return data;
  }

  async deleteFileVersion(params: types.DeleteFileVersionParameters): Promise<void> {
    await this.axios.delete(`${this.endpoint}/${params.path.fileVersionId}`);
  }

  async createSkyMapInformationModel(
    params: types.CreateSkyMapInformationModelParameters,
  ): Promise<common.GlbModel> {
    return (
      await this.axios.post(
        `${this.endpoint}/${params.path.fileVersionId}/skymap-information-model`,
      )
    ).data;
  }
}
